// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/atmosphere.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/atmosphere/atmosphere.js';
import g1 from '../lessons/meteorology/atmosphere/isa-temperature.js';

mount([g0, g1]);
